module.exports = "<span class=\"colored-label\" [ngStyle]=\"{'background-color': bgColor, 'color': textColor}\">{{ text }}</span>"


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/edi/angular/app/components/app-colored-label/app-colored-label.component.html
// module id = ../../../../../angular/app/components/app-colored-label/app-colored-label.component.html
// module chunks = main